import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../../StateProvider'
import { useHistory } from 'react-router-dom'
import { APP_ROOT } from '../../../constants/routes'
import { Button } from '../../../ui'
import i18n from 'i18next'
import cn from 'classnames'
import styles from './style.css'

const QuestionnaireFailMessage = ({ onContinue, onTryLater, className }) => {
  const [{ whitelabel: { educationMaterialUrl } }, dispatch] = useStore()
  const [isContinueLoading, setIsContinueLoading] = useState(false)
  const [isTryLaterLoading, setIsTryLaterLoading] = useState(false)
  const { t } = useTranslation()
  const history = useHistory()

  useEffect(() => {
    dispatch({ type: 'setFlag', name: 'isResendFormShown', value: false })
    return () => {
      dispatch({ type: 'setFlag', name: 'isResendFormShown', value: true })
    }
  }, [])

  const goToMainPage = () => {
    dispatch({ type: 'clearForm' })
    dispatch({ type: 'clearUser' })
    dispatch({ type: 'setTier', tier: 1 })
    history.push(APP_ROOT)
  }

  const onContinueClick = () => {
    setIsContinueLoading(true)
    onContinue()
  }

  const onTryLaterClick = () => {
    setIsTryLaterLoading(true)
    onTryLater()
  }

  return (
    <div className={cn(styles.message, className)}>
      <h1>{t('createAccountForm.warning')}</h1>
      {t('createAccountForm.questionnarieRiskWarning')}&nbsp;

      <div className={styles.buttons}>
        <Button
          onClick={onContinueClick}
          isLoading={isContinueLoading}
          disabled={isContinueLoading || isTryLaterLoading}
          isSmallSpinner
          id='onContinue'
        >
          {isContinueLoading ? <span>{' '}</span> : t('createAccount.questionnaireContinue')}
        </Button>
        <Button
          onClick={goToMainPage}
          isLoading={false}
          disabled={isContinueLoading || isTryLaterLoading}
        >
          {t('createAccount.questionnaireDoNotContinue')}
        </Button>
        <Button
          onClick={onTryLaterClick}
          isLoading={isTryLaterLoading}
          disabled={isContinueLoading || isTryLaterLoading}
          isSmallSpinner
          id='onTryLater'
        >
          {isTryLaterLoading ? <span>{' '}</span> : t('createAccount.questionnaireProceedLater')}
        </Button>
      </div>

      {educationMaterialUrl &&
        <a
          href={educationMaterialUrl[i18n.language] ||
          educationMaterialUrl.en} target='_blank' rel='noopener noreferrer'
        >
          {t('createAccountForm.questionnarieLinkText')}
        </a>}
    </div>
  )
}

export { QuestionnaireFailMessage }
